import { Link } from 'react-router-dom';

const VARIANTS = {
  primary: 'account-primary-button',
  secondary: 'account-secondary-button',
  // large tile on the create-article choice and PDF upload pages
  choice: 'create-choice-button',
  // borderless text link-style button (login page)
  text: 'login-text-button',
  // round pill on the not-found page; add className="primary" for the filled one
  error: 'error-button',
};

/**
 * A text button in one of the platform's looks.
 *
 * Like IconButton, the tag follows what it does: an action is a
 * <button type="button"> (pass type="submit" inside a form), a move to another
 * page (`to`) is a link. `ui-button` keeps both looking the same.
 *
 * `className` adds to the look (admin-danger-button, admin-group-save, ...);
 * children - text and icons - are rendered as given.
 */
function Button({
  variant = 'secondary',
  to,
  type = 'button',
  className,
  children,
  ...rest
}) {
  const classes = ['ui-button', VARIANTS[variant], className]
    .filter(Boolean)
    .join(' ');

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}

export default Button;
